// extracted by mini-css-extract-plugin
module.exports = {"title":"error-page_title__q9rTM","copy":"error-page_copy__144Fc"};